import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const StackedBlockHeaderTitle = props => {
  const { className, children, ...other } = props;
  return (
    <div className={clsx("em-c-stacked-block__title", className)} {...other}>
      {children}
    </div>
  );
};

StackedBlockHeaderTitle.propTypes = {
  /** Additional css classNames to append to the outer element */
  className: PropTypes.string,
  /** React component children */
  children: PropTypes.node
};

StackedBlockHeaderTitle.defaultProps = {
  className: "",
  children: null
};

export default StackedBlockHeaderTitle;
